import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logoOriginal from "@/assets/logo-original.svg";
import { BRAND } from "@garageregister/shared";

export function MarketingHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const onLanding = pathname === "/";
  const featuresHref = onLanding ? "#features" : "/#features";
  const pricingHref = onLanding ? "#pricing" : "/pricing";

  return (
    <header className="sticky top-0 z-50 border-b border-[#253448] bg-[#0C1222]/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center transition-opacity hover:opacity-80">
          <img src={logoOriginal} alt={BRAND.name} className="h-12" />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          <a href={featuresHref} className="text-sm font-medium text-[#7A8FA3] transition-colors hover:text-[#E8EDF2]">
            Features
          </a>
          <a href={pricingHref} className="text-sm font-medium text-[#7A8FA3] transition-colors hover:text-[#E8EDF2]">
            Pricing
          </a>
          <Link to="/signin" className="text-sm font-medium text-[#7A8FA3] transition-colors hover:text-[#E8EDF2]">
            Sign In
          </Link>
          <a
            href="/get"
            className="rounded-lg bg-[#4DB8C7] px-4 py-2 text-sm font-semibold text-[#0C1222] transition-colors hover:bg-[#3DA8B7]"
          >
            Download free
          </a>
        </nav>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden text-[#7A8FA3] hover:text-[#E8EDF2]"
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-[#253448] bg-[#0C1222] md:hidden">
          <nav className="flex flex-col gap-1 px-4 py-4">
            <a
              href={featuresHref}
              onClick={() => setMobileOpen(false)}
              className="rounded-lg px-3 py-2 text-sm font-medium text-[#7A8FA3] transition-colors hover:bg-[#151D2E] hover:text-[#E8EDF2]"
            >
              Features
            </a>
            <a
              href={pricingHref}
              onClick={() => setMobileOpen(false)}
              className="rounded-lg px-3 py-2 text-sm font-medium text-[#7A8FA3] transition-colors hover:bg-[#151D2E] hover:text-[#E8EDF2]"
            >
              Pricing
            </a>
            <Link
              to="/signin"
              onClick={() => setMobileOpen(false)}
              className="rounded-lg px-3 py-2 text-sm font-medium text-[#7A8FA3] transition-colors hover:bg-[#151D2E] hover:text-[#E8EDF2]"
            >
              Sign In
            </Link>
            <a
              href="/get"
              onClick={() => setMobileOpen(false)}
              className="mt-2 rounded-lg bg-[#4DB8C7] px-4 py-2 text-center text-sm font-semibold text-[#0C1222] transition-colors hover:bg-[#3DA8B7]"
            >
              Download free
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
